<script>
  import { fade } from 'svelte/transition';
  export let tooltipX;
  export let tooltipY;
  export let tooltipContent;
</script>

<div
  transition:fade="{{ duration: 250 }}"
  class="tooltip"
  style="
      top:{tooltipY < 100 ? tooltipY + 90 : tooltipY - 35}px;
      left:{tooltipX < 800 ? tooltipX - 300 : tooltipX - 500}px;
    "
>
  {@html tooltipContent}
</div>

<style>
  .tooltip {
    position: absolute;
    border: 1px solid #ccc;
    font-size: 13px;
    background: rgba(255, 255, 255, 0.95);
    transform: translate(-50%, -100%);
    padding: 5px;
    z-index: 15;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
    width: max-content;
  }
  :global(p.countryname) {
    font-weight: bold;
  }
  :global(span.value) {
    font-weight: bold;
  }
</style>
